export enum Color {
    /**
     * <ul>
     *      <li>Primary</li>
     *      <li>Information</li>
     * </ul>
     */
    blue1 = "#006BB3",
    /**
     * <ul>
     *      <li>Primary</li>
     * </ul>
     */
    blue2 = "#005792",
    /**
     * <ul>
     *      <li>Primary</li>
     *      <li>Information</li>
     * </ul>
     */
    blue3 = "#013A60",

    grey1 = "#F5F5F5",
    grey2 = "#E6E6E6",
    grey3 = "#DEDEDE",
    grey4 = "#BFBFBF",
    grey5 = "#7F7F7F",
    grey6 = "#323232",

    /**
     * Focus, Hover for white background -- close to `Color.grey1`
     */
    focus5 = "rgba(50, 50, 50, 0.05)", // `Color.grey6` with 5% transparency
    /**
     * Focus, Hover for white background -- close to `Color.grey2`
     */
    focus10 = "rgba(50, 50, 50, 0.10)", // `Color.grey6` with 10% transparency
    /**
     * Focus, Hover for colored background -- close to `Color.grey3`
     */
    focus20 = "rgba(50, 50, 50, 0.20)", // `Color.grey6` with 20% transparency
    /**
     * Focus, Hover for dark (colored) background -- close to `Color.grey4`
     */
    focus30 = "rgba(50, 50, 50, 0.30)", // `Color.grey6` with 30% transparency

    /**
     * <ul>
     *      <li>Secondary</li>
     *      <li>Success</li>
     * </ul>
     */
    green1 = "#98C948",
    /**
     * <ul>
     *      <li>Secondary</li>
     *      <li>Success</li>
     * </ul>
     */
    green2 = "#678931",

    /**
     * Error
     */
    red1 = "#FF0066",
    /**
     * Error
     */
    red2 = "#D90057",

    /**
     * Warning
     */
    yellow1 = "#FFCC00",
    /**
     * Warning
     */
    yellow2 = "#D4A900",

    white = "#FFFFFF",
}

/**
 * Complementary colors to visualize charts
 */
export enum ComplementaryColor {
    azure1 = "#4ECCF1",
    azure2 = "#00B9EE",
    azure3 = "#0091BB",
    gold1 = "#ECC60C",
    gold2 = "#D7B40A",
    gold3 = "#B49603",
    orange1 = "#F08C50",
    orange2 = "#E16417",
    orange3 = "#C84B00",
    turquoise1 = "#28B4B4",
    turquoise2 = "#1E7D78",
    turquoise3 = "#0A5753",
    violet1 = "#C46EEC",
    violet2 = "#9645BB",
    violet3 = "#642382",
    wood1 = "#BC7C52",
    wood2 = "#8C5532",
    wood3 = "#683B1E",
}
